import { store, getContext } from '@wordpress/interactivity';
import {decode} from 'html-entities';

const { actions, state } = store( 'golden-retriever', {
    state: {},
	actions: {
        order: (desc, articles, attributDate) => {
            return articles.sort((a, b) => {
                const date_a = new Date(a[attributDate]);
                const date_b = new Date(b[attributDate]);

                if(date_a > date_b)
                    return desc ? -1 : 1;
                else if(date_a < date_b)
                    return desc ? 1 : -1;
                return 0;
            });
        },
        formatterDate: (date) => {
            date = new Date(date);
            const date_options = {
                year: "numeric",
                month: "long",
                day: "numeric",
            };
        
            return date.toLocaleDateString("fr-CA", date_options);
        },
        getAuteur: (url) => {
            fetch(url).then( 
                async function( response ){
                    if (!response.ok)
                        return false;
                    let data = await response.json();

                    return data.name;
                }
            );
        },
        getNouvelles: function*(url, flush) {
            return fetch("/wp-admin/admin-ajax.php", 
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                    body: new URLSearchParams(
                        {
                            "url": url,
                            "flush": flush,
                            "action": "golden_retriever_get_nouvelles"
                        }
                    )
                }
            );
        }
    },
	callbacks: {
		loadData: () => {
            const context = getContext();
            let attributes = JSON.parse(context.attributes);
			const url = attributes.source_url;

            if(!url)
                return false;

            let params = new URLSearchParams(document.location.search);
            let flush = params.get("flush") ?? false;

            actions.getNouvelles(url, flush).then(
                async function( response ){
                    if (!response.ok) {
                        context.erreur = true;
                        context.chargement = false;
                        return false;
                    }
                    if(attributes.type == "rss") {
                        const data = await response.text();
                        if(!data) {
                            context.erreur = true;
                            context.chargement = false;
                            return false;
                        }
                        const feed = new DOMParser().parseFromString(data, "text/xml");
                        let items = Array.from(feed.querySelectorAll("item"));
                        if(attributes.ordre_chrono_desc)
                            items = actions.order(true, items, "pubDate");
                        if(attributes.nb_articles)
                            items = items.slice(0, parseInt(attributes.nb_articles));
        
                        let articles = [];
                        items.forEach(article => {
                            const auteur = article.getElementsByTagName("dc:creator");
                            const resume = article.getElementsByTagName("content:encoded");
                            let art = {};
                            art.titre = article.querySelector("title").innerHTML;
                            art.lien = article.querySelector("link").textContent;
                            art.date = actions.formatterDate(article.querySelector("pubDate").innerHTML);
                            art.auteur = auteur.length > 0 ? auteur[0].innerHTML : "";
                            art.resume = resume.length > 0 ? resume[0].textContent : "";
                            art.image = article.querySelector("enclosure").getAttribute("url");
                            articles.push(art);
                        });
                        context.data = articles;
                    }
                    else {
                        let items = await response.json();
                        if(attributes.ordre_chrono_desc)
                            items = actions.order(true, items, "date_gmt");
                        if(attributes.nb_articles)
                            items = items.slice(0, parseInt(attributes.nb_articles));
        
                        let articles = [];
                        items.forEach(article => {
                            let art = {};
                            
                            art.titre = decode(article.title.rendered, {level: 'html5'});;
                            art.lien = article.link;
                            art.date = actions.formatterDate(article.date_gmt);
                            art.resume = decode(article.excerpt.rendered, {level: 'html5'});
                            art.image = article['uqam:img_16-9'];
                            if(attributes.auteur) {
                                const auteur = actions.getAuteur(article["_links"].author[0].href);
                                art.auteur = auteur ?? "";
                            }
                            articles.push(art);
                        });
                        context.data = articles;
                    }
                    
                    context.chargement = false;
                }
            );
        }
	},
} );